module.exports = __webpack_public_path__ + "img/ic-mail.67037c4d.svg";